// Accepts a raw 11-char ID or any YouTube URL (watch, shorts, embed, live, youtu.be)
export function extractYouTubeId(input) {
  if (!input) return "";
  const s = String(input).trim();
  if (/^[\w-]{11}$/.test(s)) return s;
  const m = s.match(/(?:v=|\/embed\/|\/shorts\/|youtu\.be\/|\/live\/)([\w-]{11})/);
  return m ? m[1] : "";
}

export const ytThumb = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
export const ytEmbed = (id) => `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;
